import { HSOverlay } from "preline";

export function UpgradePlanModal() {
  let $modalElem: null | HTMLElement = null;

  function init() {
    $modalElem = document.getElementById("upgrade-plan-modal");
  }

  function open() {
    if ($modalElem)
      HSOverlay.open($modalElem);
  }

  function close() {
    if ($modalElem)
      HSOverlay.close($modalElem);
  }

  function render() {
    return /*html*/`
    <div id="upgrade-plan-modal" role="dialog" aria-labelledby="upgrade-plan-modal-label"
      class="hs-overlay hidden size-full fixed top-0 start-0 z-[85] overflow-x-hidden overflow-y-auto pointer-events-none"
      role="dialog" tabindex="-1" aria-labelledby="hs-scale-animation-modal-label">
      <div
        class="hs-overlay-animation-target hs-overlay-open:scale-100 hs-overlay-open:opacity-100 scale-95 opacity-0 ease-in-out transition-all duration-200 sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
        <div
          class="w-full flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-neutral-800 dark:border-neutral-700 dark:shadow-neutral-700/70">
          <div class="flex justify-between items-center py-3 px-4 border-b dark:border-neutral-700">
            <h3 id="hs-scale-animation-modal-label" class="font-bold text-gray-800 dark:text-white">
              Upgrade Plan
            </h3>
            <button type="button"
              class="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600"
              aria-label="Close" data-hs-overlay="#upgrade-plan-modal">
              <span class="sr-only">Close</span>
              <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
          <div class="p-4 overflow-y-auto">
            <div class="flex flex-col items-center text-center gap-3">
              <div>
                <img src="/images/Upgrade-Plan.svg" alt="Upgrade" width="" height="">

              </div>
              <h3 class="text-gray-800 text-lg font-semibold dark:text-white">Need more Workspace?</h3>
              <p class="text-gray-600 text-sm font-normal dark:text-neutral-500 max-w-md m-auto">Workspace helps you segregate your reviews and teams</p>
              <div
                class="w-full flex items-center gap-2 mt-2 bg-gray-50 border border-gray-200 text-sm text-gray-600 rounded-lg p-4 dark:bg-white/10 dark:border-white/10 dark:text-neutral-400"
                role="alert" tabindex="-1" aria-labelledby="hs-soft-color-secondary-label">
                <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-info">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 16v-4" />
                  <path d="M12 8h.01" />
                </svg>
                Your current plan does not allow you to create more workspace, please click below to upgrade.
              </div>
            </div>
          </div>
          <div class="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-neutral-700">
            <a href="#my-account?tab=plans" class="w-full py-2 px-3 flex text-center justify-center items-center gap-x-1 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
              <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path
                  d="M3.1665 9.33377C3.04034 9.3342 2.91665 9.29882 2.8098 9.23175C2.70295 9.16468 2.61732 9.06867 2.56287 8.95487C2.50841 8.84107 2.48736 8.71416 2.50217 8.58887C2.51697 8.46359 2.56702 8.34507 2.6465 8.2471L9.2465 1.4471C9.29601 1.38996 9.36347 1.35134 9.43782 1.33759C9.51217 1.32384 9.58898 1.33578 9.65565 1.37144C9.72232 1.4071 9.77489 1.46437 9.80472 1.53384C9.83456 1.60331 9.83988 1.68087 9.81983 1.75377L8.53983 5.7671C8.50209 5.86812 8.48941 5.97678 8.50289 6.08377C8.51637 6.19076 8.55561 6.29289 8.61723 6.38139C8.67885 6.46988 8.76101 6.54211 8.85668 6.59187C8.95235 6.64164 9.05866 6.66745 9.1665 6.6671H13.8332C13.9593 6.66667 14.083 6.70205 14.1899 6.76912C14.2967 6.83619 14.3823 6.9322 14.4368 7.046C14.4913 7.1598 14.5123 7.28671 14.4975 7.412C14.4827 7.53728 14.4326 7.6558 14.3532 7.75377L7.75317 14.5538C7.70366 14.6109 7.63619 14.6495 7.56184 14.6633C7.4875 14.677 7.41068 14.6651 7.34401 14.6294C7.27734 14.5938 7.22478 14.5365 7.19494 14.467C7.16511 14.3976 7.15978 14.32 7.17983 14.2471L8.45983 10.2338C8.49758 10.1328 8.51025 10.0241 8.49677 9.9171C8.48329 9.81011 8.44406 9.70798 8.38244 9.61948C8.32082 9.53099 8.23865 9.45876 8.14298 9.40899C8.04731 9.35923 7.941 9.33342 7.83317 9.33377H3.1665Z"
                  fill="white" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Upgrade Now
            </a>
          </div>
        </div>
      </div>
    </div>
    `;
  }

  return { init, render, open, close };
}